import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";

export const GET_LOCALES = "GET_LOCALES";
export const GET_LOCALES_SUCCESS = "GET_LOCALES_SUCCESS";
export const GET_LOCALES_ERROR = "GET_LOCALES_ERROR";

// Requests
const getLocalesGet = (fetch, apiHost, accessToken) =>
  fetch(`${apiHost}/v1/locales`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

// Actions
export function getLocales() {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_LOCALES],
    payload: {
      promise: getLocalesGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken
      )
        .then(data => {
          return data;
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/locales/actions.js